import Vue from 'vue'

const state = {
    redirect: ''
}

const actions = {
    SET_REDIRECT(context, [redirect]) {
        context.commit('SAVE_REDIRECT', [redirect])
    },
}

const mutations = {
    SAVE_REDIRECT: (state, [redirect]) => {
        Vue.set(state, 'redirect', redirect)
    },
}

const getters = {
    redirect: state => {
        return state.redirect
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}